import { Routes } from '@angular/router';
import { authGuard, publicGuard } from './core/guards/auth.guard';
import { radaTvHomeGuard } from './features/rada/shared/rada-tv-home.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [publicGuard],
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'auth/confirm-email/:token',
    loadComponent: () =>
      import('./features/auth/confirm-email/confirm-email.component').then(
        (m) => m.ConfirmEmailComponent,
      ),
  },
  {
    path: 'auth/forgot-password',
    canActivate: [publicGuard],
    loadComponent: () =>
      import('./features/auth/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
  {
    path: 'auth/reset-password/:token',
    loadComponent: () =>
      import('./features/auth/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  {
    // Fuera del shell (sin sidebar ni topbar). Va antes de la ruta '' para que el comodín
    // '**' del shell no la capture.
    path: 'rada/modo-pantalla',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/rada/modo-pantalla/modo-pantalla.component').then(
        (m) => m.ModoPantallaComponent,
      ),
  },
  {
    path: '',
    // radaTvHomeGuard: el usuario solo-TV (único permiso RADA_TV_VER) va directo al Modo pantalla.
    canActivate: [authGuard, radaTvHomeGuard],
    loadComponent: () => import('./layout/shell/shell.component').then((m) => m.ShellComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'seguridad/candados',
        loadComponent: () =>
          import('./features/seguridad/candados/candados.component').then(
            (m) => m.CandadosComponent,
          ),
      },
      {
        path: 'settings/agencias',
        loadComponent: () =>
          import('./features/settings/agencias/agencias.component').then(
            (m) => m.AgenciasComponent,
          ),
      },
      {
        path: 'settings/proveedores',
        loadComponent: () =>
          import('./features/settings/proveedores/proveedores.component').then(
            (m) => m.ProveedoresComponent,
          ),
      },
      {
        path: 'settings/checklist-personal',
        loadComponent: () =>
          import('./features/settings/checklist-personal/checklist-personal.component').then(
            (m) => m.ChecklistPersonalComponent,
          ),
      },
      {
        path: 'settings/checklist-ro',
        loadComponent: () =>
          import('./features/settings/checklist-ro/checklist-ro.component').then(
            (m) => m.ChecklistRoComponent,
          ),
      },
      {
        path: 'settings/usuarios',
        loadComponent: () =>
          import('./features/settings/usuarios/usuarios.component').then(
            (m) => m.UsuariosComponent,
          ),
      },
      {
        path: 'settings/novedades',
        loadComponent: () =>
          import('./features/settings/novedades/novedades.component').then(
            (m) => m.NovedadesComponent,
          ),
      },
      {
        path: 'settings/galaxia-planeta',
        loadComponent: () =>
          import('./features/settings/galaxia-planeta/planetas.component').then(
            (m) => m.PlanetasComponent,
          ),
      },
      {
        path: 'settings/visitas',
        loadComponent: () =>
          import('./features/settings/visitas/visitas.component').then((m) => m.VisitasComponent),
      },
      {
        path: 'distribution/auditoria',
        loadComponent: () =>
          import('./features/distribution/auditoria/auditoria.component').then(
            (m) => m.AuditoriaComponent,
          ),
      },
      {
        path: 'distribution/rutas',
        loadComponent: () =>
          import('./features/distribution/rutas/rutas.component').then((m) => m.RutasComponent),
      },
      {
        path: 'distribution/planning',
        loadComponent: () =>
          import('./features/distribution/planning/planning.component').then(
            (m) => m.PlanningComponent,
          ),
      },
      {
        path: 'distribution/retorno-ruta',
        loadComponent: () =>
          import('./features/distribution/retorno-ruta/retorno-ruta.component').then(
            (m) => m.RetornoRutaComponent,
          ),
      },
      {
        path: 'distribution/tracking',
        loadComponent: () =>
          import('./features/distribution/tracking/tracking.component').then(
            (m) => m.TrackingComponent,
          ),
      },
      {
        path: 'distribution/leadtime-monitoreo',
        loadComponent: () =>
          import('./features/distribution/leadtime-monitoreo/leadtime-monitoreo.component').then(
            (m) => m.LeadtimeMonitoreoComponent,
          ),
      },
      {
        path: 'settings/jornadas',
        loadComponent: () =>
          import('./features/settings/jornadas/jornadas.component').then(
            (m) => m.JornadasComponent,
          ),
      },
      {
        path: 'settings/asistencia',
        loadComponent: () =>
          import('./features/settings/asistencia/asistencia.component').then(
            (m) => m.AsistenciaComponent,
          ),
      },
      {
        path: 'settings/linehaul',
        loadComponent: () =>
          import('./features/settings/linehaul/linehaul.component').then(
            (m) => m.LinehaulComponent,
          ),
      },
      {
        path: 'settings/planificador-lh',
        loadComponent: () =>
          import('./features/settings/planificador-lh/planificador-lh.component').then(
            (m) => m.PlanificadorLhComponent,
          ),
      },
      {
        path: 'settings/plan-de-viaje-lh',
        loadComponent: () =>
          import('./features/settings/plan-de-viaje-lh/plan-de-viaje-lh.component').then(
            (m) => m.PlanDeViajeLhComponent,
          ),
      },
      {
        path: 'settings/control-arribos',
        loadComponent: () =>
          import('./features/settings/control-arribos/control-arribos.component').then(
            (m) => m.ControlArribosComponent,
          ),
      },
      {
        path: 'settings/molinete',
        loadComponent: () =>
          import('./features/settings/molinete/molinete.component').then(
            (m) => m.MolineteComponent,
          ),
      },
      {
        path: 'settings/tickets',
        loadComponent: () =>
          import('./features/settings/tickets/tickets.component').then((m) => m.TicketsComponent),
      },
      {
        path: 'despachos/gestion-despachos',
        loadComponent: () =>
          import('./features/despachos/gestion-despachos/gestion-despachos.component').then(
            (m) => m.GestionDespachosComponent,
          ),
      },
      {
        path: 'distribution/geo-ext',
        loadComponent: () =>
          import('./features/georef/georeferenciador-externo/geo-ext.component').then(
            (m) => m.GeoExtComponent,
          ),
      },
      {
        path: 'distribution/geo-ext/reporte',
        loadComponent: () =>
          import('./features/georef/georeferenciador-externo/reporte/reporte.component').then(
            (m) => m.GeoExtReporteComponent,
          ),
      },
      {
        path: 'recoleccion/admision-origen',
        loadComponent: () =>
          import('./features/recoleccion/admision-origen/admision-origen.component').then(
            (m) => m.AdmisionOrigenComponent,
          ),
      },
      {
        path: 'recoleccion/planning-recoleccion',
        loadComponent: () =>
          import('./features/recoleccion/planning-recoleccion/planning-recoleccion.component').then(
            (m) => m.PlanningRecoleccionComponent,
          ),
      },
      {
        path: 'claim/siniestros',
        loadComponent: () =>
          import('./features/claim/siniestros/siniestros.component').then(
            (m) => m.SiniestrosComponent,
          ),
      },
      {
        path: 'admision/sorter-formulas',
        loadComponent: () =>
          import('./features/admision/sorter-formulas/sorter-formulas.component').then(
            (m) => m.SorterFormulasComponent,
          ),
      },
      {
        // EP-ADM-01B · R12 — Completar peso y medidas de guías admitidas sin dato.
        path: 'admision/completar-medidas',
        loadComponent: () =>
          import('./features/admision/completar-medidas/completar-medidas.component').then(
            (m) => m.CompletarMedidasComponent,
          ),
      },
      {
        path: 'georef/georeferenciador-externo',
        loadComponent: () =>
          import('./features/georef/georeferenciador-externo/geo-ext.component').then(
            (m) => m.GeoExtComponent,
          ),
      },
      {
        path: 'dashboard/reportes/gerencia',
        loadComponent: () =>
          import('./features/dashboard/reportes/gerencia/gerencia.component').then(
            (m) => m.GerenciaComponent,
          ),
      },
      {
        path: 'dashboard/reportes/interbank',
        loadComponent: () =>
          import('./features/dashboard/reportes/interbank/interbank.component').then(
            (m) => m.InterbankComponent,
          ),
      },
      {
        path: 'dashboard/reportes/novedades',
        loadComponent: () =>
          import('./features/dashboard/reportes/novedades/novedades.component').then(
            (m) => m.ReporteNovedadesComponent,
          ),
      },
      {
        path: 'distribution/monitoreo-en-ruta',
        loadComponent: () =>
          import('./features/distribution/monitoreo-en-ruta/monitoreo-en-ruta.component').then(
            (m) => m.MonitoreoEnRutaComponent,
          ),
      },
      {
        path: 'rada/productividad-despacho',
        loadComponent: () =>
          import('./features/rada/productividad-despacho/productividad-despacho.component').then(
            (m) => m.ProductividadDespachoComponent,
          ),
      },
      {
        path: 'rada/metas-activacion',
        loadComponent: () =>
          import('./features/rada/metas-activacion/metas-activacion.component').then(
            (m) => m.MetasActivacionComponent,
          ),
      },
      {
        path: 'rada/dashboard-activacion',
        loadComponent: () =>
          import('./features/rada/dashboard-activacion/dashboard-activacion.component').then(
            (m) => m.DashboardActivacionComponent,
          ),
      },
      {
        path: '**',
        loadComponent: () =>
          import('./features/under-construction/under-construction.component').then(
            (m) => m.UnderConstructionComponent,
          ),
      },
    ],
  },
];
